export interface Phoneme {
  symbol: string;
  example: string;
  audio: string;
  description: string;
}

export interface PhonemeSet {
  vowels: Phoneme[];
  consonants: Phoneme[];
}

export const ukPhonemes: PhonemeSet = {
  vowels: [
    { symbol: 'iː', example: 'see', audio: '/phonetics/audio/uk/i.mp3', description: '前元音，长元音' },
    { symbol: 'ɪ', example: 'sit', audio: '/phonetics/audio/uk/ɪ.mp3', description: '前元音，短元音' },
    { symbol: 'e', example: 'bed', audio: '/phonetics/audio/uk/e.mp3', description: '前元音，短元音' },
    { symbol: 'æ', example: 'cat', audio: '/phonetics/audio/uk/æ.mp3', description: '前元音，短元音' },
    { symbol: 'ɜː', example: 'bird', audio: '/phonetics/audio/uk/ɜ.mp3', description: '中元音，长元音' },
    { symbol: 'ə', example: 'about', audio: '/phonetics/audio/uk/ə.mp3', description: '中元音，短元音' },
    { symbol: 'ʌ', example: 'cup', audio: '/phonetics/audio/uk/ʌ.mp3', description: '中元音，短元音' },
    { symbol: 'uː', example: 'food', audio: '/phonetics/audio/uk/u.mp3', description: '后元音，长元音' },
    { symbol: 'ʊ', example: 'book', audio: '/phonetics/audio/uk/ʊ.mp3', description: '后元音，短元音' },
    { symbol: 'ɔː', example: 'law', audio: '/phonetics/audio/uk/ɔ.mp3', description: '后元音，长元音' },
    { symbol: 'ɒ', example: 'hot', audio: '/phonetics/audio/uk/ɒ.mp3', description: '后元音，短元音' },
    { symbol: 'ɑː', example: 'car', audio: '/phonetics/audio/uk/ɑ.mp3', description: '后元音，长元音' },
    { symbol: 'eɪ', example: 'day', audio: '/phonetics/audio/uk/eɪ.mp3', description: '合口双元音' },
    { symbol: 'aɪ', example: 'eye', audio: '/phonetics/audio/uk/aɪ.mp3', description: '合口双元音' },
    { symbol: 'ɔɪ', example: 'boy', audio: '/phonetics/audio/uk/ɔɪ.mp3', description: '合口双元音' },
    { symbol: 'əʊ', example: 'go', audio: '/phonetics/audio/uk/əʊ.mp3', description: '合口双元音' },
    { symbol: 'aʊ', example: 'now', audio: '/phonetics/audio/uk/aʊ.mp3', description: '合口双元音' },
    { symbol: 'ɪə', example: 'here', audio: '/phonetics/audio/uk/ɪə.mp3', description: '集中双元音' },
    { symbol: 'eə', example: 'air', audio: '/phonetics/audio/uk/eə.mp3', description: '集中双元音' },
    { symbol: 'ʊə', example: 'tour', audio: '/phonetics/audio/uk/ʊə.mp3', description: '集中双元音' }
  ],
  consonants: [
    { symbol: 'p', example: 'pen', audio: '/phonetics/audio/uk/p.mp3', description: '清辅音，双唇爆破音' },
    { symbol: 'b', example: 'boy', audio: '/phonetics/audio/uk/b.mp3', description: '浊辅音，双唇爆破音' },
    { symbol: 't', example: 'ten', audio: '/phonetics/audio/uk/t.mp3', description: '清辅音，齿龈爆破音' },
    { symbol: 'd', example: 'dog', audio: '/phonetics/audio/uk/d.mp3', description: '浊辅音，齿龈爆破音' },
    { symbol: 'k', example: 'cat', audio: '/phonetics/audio/uk/k.mp3', description: '清辅音，软腭爆破音' },
    { symbol: 'g', example: 'go', audio: '/phonetics/audio/uk/g.mp3', description: '浊辅音，软腭爆破音' },
    { symbol: 'f', example: 'fish', audio: '/phonetics/audio/uk/f.mp3', description: '清辅音，唇齿摩擦音' },
    { symbol: 'v', example: 'voice', audio: '/phonetics/audio/uk/v.mp3', description: '浊辅音，唇齿摩擦音' },
    { symbol: 'θ', example: 'think', audio: '/phonetics/audio/uk/θ.mp3', description: '清辅音，齿间摩擦音' },
    { symbol: 'ð', example: 'this', audio: '/phonetics/audio/uk/ð.mp3', description: '浊辅音，齿间摩擦音' },
    { symbol: 's', example: 'sun', audio: '/phonetics/audio/uk/s.mp3', description: '清辅音，齿龈摩擦音' },
    { symbol: 'z', example: 'zoo', audio: '/phonetics/audio/uk/z.mp3', description: '浊辅音，齿龈摩擦音' },
    { symbol: 'ʃ', example: 'she', audio: '/phonetics/audio/uk/ʃ.mp3', description: '清辅音，腭龈摩擦音' },
    { symbol: 'ʒ', example: 'vision', audio: '/phonetics/audio/uk/ʒ.mp3', description: '浊辅音，腭龈摩擦音' },
    { symbol: 'h', example: 'hot', audio: '/phonetics/audio/uk/h.mp3', description: '清辅音，声门摩擦音' },
    { symbol: 'tʃ', example: 'chat', audio: '/phonetics/audio/uk/tʃ.mp3', description: '清辅音，腭龈塞擦音' },
    { symbol: 'dʒ', example: 'jump', audio: '/phonetics/audio/uk/dʒ.mp3', description: '浊辅音，腭龈塞擦音' },
    { symbol: 'm', example: 'man', audio: '/phonetics/audio/uk/m.mp3', description: '浊辅音，双唇鼻音' },
    { symbol: 'n', example: 'no', audio: '/phonetics/audio/uk/n.mp3', description: '浊辅音，齿龈鼻音' },
    { symbol: 'ŋ', example: 'sing', audio: '/phonetics/audio/uk/ŋ.mp3', description: '浊辅音，软腭鼻音' },
    { symbol: 'l', example: 'leg', audio: '/phonetics/audio/uk/l.mp3', description: '浊辅音，齿龈边音' },
    { symbol: 'r', example: 'red', audio: '/phonetics/audio/uk/r.mp3', description: '浊辅音，齿龈近音' },
    { symbol: 'j', example: 'yes', audio: '/phonetics/audio/uk/j.mp3', description: '浊辅音，硬腭近音' },
    { symbol: 'w', example: 'wet', audio: '/phonetics/audio/uk/w.mp3', description: '浊辅音，双唇近音' }
  ]
};

export const usPhonemes: PhonemeSet = {
  vowels: [
    { symbol: 'i', example: 'see', audio: '/phonetics/audio/us/i.mp3', description: '前元音' },
    { symbol: 'ɪ', example: 'sit', audio: '/phonetics/audio/us/ɪ.mp3', description: '前元音' },
    { symbol: 'e', example: 'bed', audio: '/phonetics/audio/us/e.mp3', description: '前元音' },
    { symbol: 'æ', example: 'cat', audio: '/phonetics/audio/us/æ.mp3', description: '前元音' },
    { symbol: 'ə', example: 'about', audio: '/phonetics/audio/us/ə.mp3', description: '中元音' },
    { symbol: 'ɚ', example: 'teacher', audio: '/phonetics/audio/us/ɚ.mp3', description: '中元音，儿化' },
    { symbol: 'ɝ', example: 'bird', audio: '/phonetics/audio/us/ɝ.mp3', description: '中元音，重读儿化' },
    { symbol: 'ʌ', example: 'cup', audio: '/phonetics/audio/us/ʌ.mp3', description: '中元音' },
    { symbol: 'u', example: 'food', audio: '/phonetics/audio/us/u.mp3', description: '后元音' },
    { symbol: 'ʊ', example: 'book', audio: '/phonetics/audio/us/ʊ.mp3', description: '后元音' },
    { symbol: 'ɔ', example: 'law', audio: '/phonetics/audio/us/ɔ.mp3', description: '后元音' },
    { symbol: 'ɑ', example: 'hot', audio: '/phonetics/audio/us/ɑ.mp3', description: '后元音' },
    { symbol: 'eɪ', example: 'day', audio: '/phonetics/audio/us/eɪ.mp3', description: '双元音' },
    { symbol: 'aɪ', example: 'eye', audio: '/phonetics/audio/us/aɪ.mp3', description: '双元音' },
    { symbol: 'ɔɪ', example: 'boy', audio: '/phonetics/audio/us/ɔɪ.mp3', description: '双元音' },
    { symbol: 'oʊ', example: 'go', audio: '/phonetics/audio/us/oʊ.mp3', description: '双元音' },
    { symbol: 'aʊ', example: 'now', audio: '/phonetics/audio/us/aʊ.mp3', description: '双元音' }
  ],
  consonants: [
    { symbol: 'p', example: 'pen', audio: '/phonetics/audio/us/p.mp3', description: '清辅音，双唇爆破音' },
    { symbol: 'b', example: 'boy', audio: '/phonetics/audio/us/b.mp3', description: '浊辅音，双唇爆破音' },
    { symbol: 't', example: 'ten', audio: '/phonetics/audio/us/t.mp3', description: '清辅音，齿龈爆破音' },
    { symbol: 'd', example: 'dog', audio: '/phonetics/audio/us/d.mp3', description: '浊辅音，齿龈爆破音' },
    { symbol: 'k', example: 'cat', audio: '/phonetics/audio/us/k.mp3', description: '清辅音，软腭爆破音' },
    { symbol: 'g', example: 'go', audio: '/phonetics/audio/us/g.mp3', description: '浊辅音，软腭爆破音' },
    { symbol: 'f', example: 'fish', audio: '/phonetics/audio/us/f.mp3', description: '清辅音，唇齿摩擦音' },
    { symbol: 'v', example: 'voice', audio: '/phonetics/audio/us/v.mp3', description: '浊辅音，唇齿摩擦音' },
    { symbol: 'θ', example: 'think', audio: '/phonetics/audio/us/θ.mp3', description: '清辅音，齿间摩擦音' },
    { symbol: 'ð', example: 'this', audio: '/phonetics/audio/us/ð.mp3', description: '浊辅音，齿间摩擦音' },
    { symbol: 's', example: 'sun', audio: '/phonetics/audio/us/s.mp3', description: '清辅音，齿龈摩擦音' },
    { symbol: 'z', example: 'zoo', audio: '/phonetics/audio/us/z.mp3', description: '浊辅音，齿龈摩擦音' },
    { symbol: 'ʃ', example: 'she', audio: '/phonetics/audio/us/ʃ.mp3', description: '清辅音，腭龈摩擦音' },
    { symbol: 'ʒ', example: 'vision', audio: '/phonetics/audio/us/ʒ.mp3', description: '浊辅音，腭龈摩擦音' },
    { symbol: 'h', example: 'hot', audio: '/phonetics/audio/us/h.mp3', description: '清辅音，声门摩擦音' },
    { symbol: 'tʃ', example: 'chat', audio: '/phonetics/audio/us/tʃ.mp3', description: '清辅音，腭龈塞擦音' },
    { symbol: 'dʒ', example: 'jump', audio: '/phonetics/audio/us/dʒ.mp3', description: '浊辅音，腭龈塞擦音' },
    { symbol: 'm', example: 'man', audio: '/phonetics/audio/us/m.mp3', description: '浊辅音，双唇鼻音' },
    { symbol: 'n', example: 'no', audio: '/phonetics/audio/us/n.mp3', description: '浊辅音，齿龈鼻音' },
    { symbol: 'ŋ', example: 'sing', audio: '/phonetics/audio/us/ŋ.mp3', description: '浊辅音，软腭鼻音' },
    { symbol: 'l', example: 'leg', audio: '/phonetics/audio/us/l.mp3', description: '浊辅音，齿龈边音' },
    { symbol: 'r', example: 'red', audio: '/phonetics/audio/us/r.mp3', description: '浊辅音，齿龈近音' },
    { symbol: 'j', example: 'yes', audio: '/phonetics/audio/us/j.mp3', description: '浊辅音，硬腭近音' },
    { symbol: 'w', example: 'wet', audio: '/phonetics/audio/us/w.mp3', description: '浊辅音，双唇近音' }
  ]
};